import { useEffect, useState } from "react";
import AppLayout from "@/components/AppLayout";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";
import { toast } from "sonner";
import ExperimentalSettings from "@/components/ExperimentalSettings";

const STATUSES = ["Nova", "Em contato", "Agendada", "Realizada", "Convertida", "Arquivada"];

export default function AdminExperimental() {
  const [items, setItems] = useState([]);
  const [statusFilter, setStatusFilter] = useState("Todas");
  const load = () => api.get("/experimental").then(r => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const update = async (id, status) => {
    await api.patch(`/experimental/${id}`, { status, admin_notes: "" });
    toast.success("Status atualizado"); await load();
  };
  const counts = Object.fromEntries(STATUSES.map(status => [status, items.filter(item => item.status === status).length]));
  const filteredItems = statusFilter === "Todas" ? items : items.filter(item => item.status === statusFilter);
  return (
    <AppLayout kind="admin">
      <h1 className="text-3xl sm:text-4xl text-white font-semibold mb-2">Aulas Experimentais</h1>
      <p className="text-slate-400 mb-8">Gerencie as informações da aula e as solicitações recebidas pelo site.</p>
      <ExperimentalSettings />
      <h2 className="text-xl text-white font-semibold mb-4">Solicitações recebidas</h2>
      <div className="mb-6 overflow-x-auto pb-1">
        <div className="flex min-w-max gap-2" role="tablist" aria-label="Filtrar solicitações por status">
          {["Todas", ...STATUSES].map(status => {
            const count = status === "Todas" ? items.length : counts[status];
            const active = statusFilter === status;
            return <button key={status} type="button" role="tab" aria-selected={active} onClick={() => setStatusFilter(status)}
              className={`rounded-full border px-3 py-2 text-sm transition-colors ${active ? "border-amber-400 bg-amber-500 text-[#071A33] font-semibold" : "border-amber-500/20 bg-[#0D2A52] text-slate-300 hover:border-amber-400/60 hover:text-white"}`}>
              {status} <span className={active ? "text-[#071A33]/75" : "text-amber-300"}>({count})</span>
            </button>;
          })}
        </div>
      </div>
      <div className="grid md:grid-cols-2 gap-4">
        {filteredItems.map(r => (
          <Card key={r.id} className="bg-transparent gsx-card-dark p-5" data-testid={`exp-${r.id}`}>
            <div className="flex justify-between items-start flex-wrap gap-2">
              <div>
                <div className="text-white font-semibold">{r.student_name} ({r.age} anos)</div>
                <div className="text-xs text-slate-400">Resp.: {r.responsible_name}</div>
                <div className="text-xs text-slate-400">{r.email} • {r.phone}</div>
              </div>
              <span className="text-xs px-2 py-1 rounded bg-amber-500/15 text-amber-300">{r.status}</span>
            </div>
            <div className="text-xs text-slate-300 mt-3">Nível: <b>{r.level}</b> • Melhor dia: {r.best_day} {r.best_time}</div>
            {r.location && <p className="text-xs text-slate-400 mt-2">Local: {r.location}</p>}
            {r.notes && <p className="text-xs text-slate-400 mt-2">{r.notes}</p>}
            <div className="mt-4">
              <Select value={r.status} onValueChange={(v) => update(r.id, v)}>
                <SelectTrigger data-testid={`exp-status-${r.id}`} className="bg-[#0D2A52] border-amber-500/20 text-white h-9"><SelectValue /></SelectTrigger>
                <SelectContent>{STATUSES.map(s => <SelectItem key={s} value={s}>{s}</SelectItem>)}</SelectContent>
              </Select>
            </div>
          </Card>
        ))}
        {!items.length && <div className="text-slate-400 col-span-full">Nenhuma solicitação recebida.</div>}
        {items.length > 0 && !filteredItems.length && <div className="text-slate-400 col-span-full">Nenhuma inscrição encontrada com o status {statusFilter}.</div>}
      </div>
    </AppLayout>
  );
}
